/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserStatsDto } from '../../models/user-stats-dto';

export interface AdminStatsControllerGetUserStats$Params {
}

export function adminStatsControllerGetUserStats(http: HttpClient, rootUrl: string, params?: AdminStatsControllerGetUserStats$Params, context?: HttpContext): Observable<StrictHttpResponse<UserStatsDto>> {
  const rb = new RequestBuilder(rootUrl, adminStatsControllerGetUserStats.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserStatsDto>;
    })
  );
}

adminStatsControllerGetUserStats.PATH = '/admin-stats/users';
